import React from 'react'

const FacebookIcon = (props) => (
    <svg {...props} width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="18" cy="18" r="18" fill="#6B8A6E"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M15.6112 25.586V17.793H14V15.1067H15.6112V13.4946C15.6112 11.3046 16.5214 10 19.1049 10H21.2568V12.6863H19.9123C18.9064 12.6863 18.8391 13.0621 18.8391 13.7622L18.8355 15.1067H21.2728L20.9874 17.793H18.8355V25.586H15.6112Z" fill="white"/>
    </svg>
)

export default FacebookIcon;